<thead>
  <tr>
    <th>Local name</th>
    <th>Type</th>
    <th>OSM</th>
    <th>Address rank</th>
    <th>Admin level</th>
    <th>Distance</th>
    <th></th>
  </tr>
</thead>